import { create } from 'zustand';
import { AlertColor } from '@mui/material';

import { NotificationMessage } from '@/types';

type NotificationStore = {
  notificationMessages: NotificationMessage[];
  notificationsAllowed: boolean;
  showNotification: (severity: AlertColor, message: string, onClose?: () => void, timeoutSec?: number) => void;
  shift: () => void;
  clearAllNotifications: () => void;
  setNotificationsAllowed: (allowed: boolean) => void;
};

function isDuplicate(current: NotificationMessage[], newNotificationMessage: NotificationMessage) {
  return current.find((value) => value.message === newNotificationMessage.message) !== undefined;
}

const useNotificationStore = create<NotificationStore>((set) => ({
  notificationMessages: [],
  notificationsAllowed: true,
  showNotification: (severity: AlertColor, message: string, onClose?: () => void, timeoutSec?: number) =>
    set((state) => {
      if (!state.notificationsAllowed) return {}; // ez a notification elveszik

      const newNotificationMessage = {
        severity,
        message,
        onClose,
        timeoutSec,
      } satisfies NotificationMessage;

      if (isDuplicate(state.notificationMessages, newNotificationMessage)) return {};

      return {
        notificationMessages: [...state.notificationMessages, newNotificationMessage],
      };
    }),
  shift: () =>
    set((state) => {
      return {
        notificationMessages: state.notificationMessages.slice(1),
      };
    }),
  clearAllNotifications: () => set({ notificationMessages: [] }),
  setNotificationsAllowed: (allowed: boolean) => set({ notificationsAllowed: allowed, notificationMessages: [] }), // toroljuk a notification-oket
}));

export { useNotificationStore };
